import React, { useState } from 'react';
import Media from 'react-media';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Flex, GradientButton } from '../../../components';

import Logo from '../../../assets/Logo.png';

const Container = styled(Flex)`
  margin: 40px 0;
  position: relative;
`;

const A = styled.a`
  font-size: 16px;
  color: ${props => (props.active ? '#FC8895' : '#7178B2')};
  transition: opacity 200ms;
  &:hover {
    opacity: 0.5;
  }
`;

const MobileToggle = styled.div`
  height: 30px;
  width: 50px;
  position: relative;
  z-index: 1000;
  div {
    position: absolute;
    left: 50%;
    width: 100%;
    border: 2px solid white;
    transform: translate(-50%, -50%);
    transition: transform 300ms, top 300ms 200ms;
    &.one {
      top: 25%;
    }
    &.two {
      top: 75%;
    }
  }
  ${props =>
    props.open &&
    `
      div {
        top: 50%!important;
        transition: transform 200ms 300ms, top 200ms;
        &.one { transform: translate(-50%, -50%) rotate(45deg); }
        &.two { transform: translate(-50%, -50%) rotate(-45deg); }
      }
  `}
`;

const MobileLinkContainer = styled(Flex)`
  z-index: 100;
  align-items: center;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s cubic-bezier(1, 0, 0, 1);
  background: #101225;
  @supports (-webkit-backdrop-filter: blur()) {
    background-color: rgba(16, 18, 37, 0.502);
    -webkit-backdrop-filter: blur(35px);
  }
  ${props => (props.open ? `max-height: 1000px;transition: max-height 1s ease-in-out;` : '')};
`;

const Navbar = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const onLinkClick = () => setOpen(false);

  const openDash = () => history.push('/dashboard');

  return (
    <Container dir="row" w="100%" h="60px" align="center">
      <Flex w="150px">
        <img style={{ zIndex: 1000 }} src={Logo} alt="" />
      </Flex>
      <Media query={{ minWidth: 710 }}>
        {matches =>
          matches ? (
            <>
              <Flex fg="1" />
              <A active onClick={onLinkClick} href="#home">
                Home
              </A>
              <Flex w="25px" />
              <A onClick={onLinkClick} href="#features">
                Features
              </A>
              <Flex w="25px" />
              <A onClick={onLinkClick} href="#sitelist">
                Sitelist
              </A>
              <Flex w="25px" />
              <A onClick={onLinkClick} href="#faq">
                FAQ
              </A>
              <Flex fg="1" />
              <GradientButton onClick={openDash} text="Dashboard" />
            </>
          ) : (
            <>
              <Flex fg="1" />
              <MobileToggle open={open} onClick={() => setOpen(!open)}>
                <div className="one" />
                <div className="two" />
              </MobileToggle>
              <MobileLinkContainer dir="column" open={open}>
                <Flex h="25px" />
                <A active onClick={onLinkClick} href="#home">
                  Home
                </A>
                <Flex h="25px" />
                <A onClick={onLinkClick} href="#features">
                  Features
                </A>
                <Flex h="25px" />
                <A onClick={onLinkClick} href="#sitelist">
                  Sitelist
                </A>
                <Flex h="25px" />
                <A onClick={onLinkClick} href="#faq">
                  FAQ
                </A>
                <Flex h="25px" />
                <GradientButton onClick={openDash} text="Dashboard" />
                <Flex h="25px" />
              </MobileLinkContainer>
            </>
          )
        }
      </Media>
    </Container>
  );
};

export default Navbar;
